export const environment = {
  production: false,
  apiUrl: 'https://x53wqeum79.execute-api.us-east-1.amazonaws.com/dev/api/v1'
};
